import { render, staticRenderFns } from "./supplierDetail.vue?vue&type=template&id=5dfe633e&scoped=true"
import script from "./supplierDetail.vue?vue&type=script&lang=js"
export * from "./supplierDetail.vue?vue&type=script&lang=js"
import style0 from "./supplierDetail.vue?vue&type=style&index=0&id=5dfe633e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe633e",
  null
  
)

export default component.exports